module.exports = __webpack_public_path__ + "static/media/profilepicture.23b60d4d.jpeg";